import React from "react";
import { HomeLayout } from "@/modules/home/components/HomeLayout";

export const Home: React.FC = () => {
  return <HomeLayout />;
};
